(() => {
  const initDiwaliPopup = () => {
    const popup = document.getElementById('UtsoviaDiwaliPopup');
    if (!popup || popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';
    let closeTimer;
    const closePopup = () => {
      window.clearTimeout(closeTimer);
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown);
    };
    const onKeydown = (event) => {
      if (event.key === 'Escape') closePopup();
    };
    popup.querySelectorAll('[data-diwali-dismiss]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });
    window.setTimeout(() => {
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onKeydown);
      closeTimer = window.setTimeout(closePopup, 5000);
    }, 700);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiwaliPopup, { once: true });
  } else {
    initDiwaliPopup();
  }
})();